import sgp from '../../assets/static/teamwork/sgp.png';
import dop from '../../assets/static/teamwork/dop.png';
import logo from '../../assets/static/teamwork/logo.png';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    'teamwork': [
      { 'id': 1,
        'name':'Sebastian García P.',
        'career':'MEDICO GENERAL',
        'img': sgp,
        'logo': logo,
      },
      { 'id': 2,
        'name':'Daniela Orozco P.',
        'career':'FISIOTERAPEUTA',
        'img': dop,
        'logo': logo,
      },
    ],
  };